<template>
  <form class="storefinderQuickstart" :action="actionWithTagUid">
    <header class="storefinderQuickstart__header">
      <div class="storefinderQuickstart__title">{{ staticTextTitle }}</div>
      <p class="storefinderQuickstart__subtitle">{{ staticTextSubtitle }}</p>
    </header>
    <div class="storefinderQuickstart__inputFields">
      <input :placeholder="staticTextYourCityZip" type="text" v-model="form.search" @input="updateInputCache"/>

      <button class="storefinderQuickstart__button">
        <div class="storefinderQuickstart__buttonContainer">
          <span class="storefinderQuickstart__button__text storefinderQuickstart__button__icon">
            <slot></slot>
            {{ staticTextFind }}
          </span>
        </div>
      </button>
    </div>
  </form>
</template>

<script>

  export default {
    name: 'storefinder-quickstart',

    data: function () {
      return {
        form: {
          search: '',
        },
      };
    },

    props: [
      'action',
      'staticTextTitle',
      'staticTextSubtitle',
      'staticTextYourCityZip',
      'staticTextFind',
      'pageUid',
    ],

    computed: {
      actionWithTagUid() {
        if (!this.pageUid) {
          return this.action;
        }

        return `${this.action}#/${this.pageUid}`;
      },
    },

    methods: {
      updateInputCache() {
        localStorage.setItem('search', this.form.search);
        localStorage.setItem('radius', '999');
        localStorage.setItem('country', 'DE');
      },
    },

    mounted() {
      this.form.search = localStorage.getItem('search') || '';
    },
  };
</script>
